import React from 'react'
import { AcademyEvent } from '../../../../Api'
import { Head3 } from '../../../../Components/Typography/Text.styles'
import { AcademyEventCard } from '../../Events/components/AcademyEventCard'
import { CardSwiper } from '../../../../Components/CardSwiper'

type GirlsEventsParams = {
  events: AcademyEvent[]
}

export const GirlsEvents: React.FC<GirlsEventsParams> = ({ events }) => {
  return (
    <>
    {events.length > 0 &&
      <CardSwiper
      items={events.map((ev) => <AcademyEventCard key={ev.academyEventId} ev={ev} />)}
      cardSize={'academyEvent'}
    />}
    {events.length < 1 && (
      <Head3>Currently no training events. Try reseting the filters.</Head3>
    )}
    </>
  )

}